// pricingData.js
export const pricingPlans = [
  {
    id: 'free',
    title: 'Free',
    description:
      'Discover CyberLabs and experience real cybersecurity labs with zero commitment.',
    price: 0,
    popular: false,
    cta: 'Start Free',
    features: {
      introLabs: true,
      basicSim: true,
      community: true,
      runtime: false,
      paths: false,
      walkthroughs: false,
      tracking: false,
      certs: false,
      advancedLabs: false,
      blueRed: false,
      irForensics: false,
      badges: false,
      prioritySupport: false,
      earlyAccess: false,
    },
  },

  {
    id: 'student',
    title: 'Student',
    description:
      'Built for students and fresh graduates who want structured cybersecurity learning.',
    price: 2.9,
    popular: false,
    cta: 'Become a Student',
    features: {
      introLabs: true,
      basicSim: true,
      community: true,
      runtime: true,
      paths: true,
      walkthroughs: true,
      tracking: true,
      certs: true,
      advancedLabs: false,
      blueRed: false,
      irForensics: false,
      badges: false,
      prioritySupport: false,
      earlyAccess: false,
    },
  },

  {
    id: 'pro',
    title: 'Pro',
    description:
      'For cybersecurity professionals who want real-world, job-ready experience.',
    price: 29,
    popular: true,
    cta: 'Upgrade to Pro',
    features: {
      introLabs: true,
      basicSim: true,
      community: true,
      runtime: true,
      paths: true,
      walkthroughs: true,
      tracking: true,
      certs: true,
      advancedLabs: true,
      blueRed: true,
      irForensics: true,
      badges: true,
      prioritySupport: true,
      earlyAccess: true,
    },
  },
];
